import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Typography,
  Paper,
  Grid,
  Divider,
  Button,
  Autocomplete,
  useTheme,
  useMediaQuery,
  Stack,
  Card,
  CardActions,
  IconButton,
  Icon,
} from "@mui/material";
import CustomerListContainer from "../../containers/CustomerListContainer/CustomerListContainer";
import { useDispatch } from "react-redux";
import { fetchDevicesConfigs } from "../../../src/Dashboard/ducks/devicesConfigsDuck";
import config from "config";
import { DevicesConfig, sensorManagement } from "../../../src/Dashboard/actions/apiActions";
import AddSensors from "./AddSensors";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import SensorCard from "./SensorCard";
import useDeleteConfirm from "../common/DeleteConfirmDialog";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const SensorManagementListItem = ({
  sensor,
  selectedSensorSite,
  fetchSensorsForEdgeUnit,
  copySensorToNewSensorCard,
}) => {
  const [editing, setEditing] = useState(false);
  const [getDeleteConfirmation, DeleteConfirmationDialog] = useDeleteConfirm();

  const handleSetEditing = (value) => {
    setEditing(value);
  };

  const deleteSensor = async () => {
    const userConfirmed = await getDeleteConfirmation({
      //   title: t('deleteConfirmDialog.title'),
      //   text: t('deleteConfirmDialog.text'),
      //   itemName: sensor.hwId,
      //   okText: t('deleteConfirmDialog.okText'),
      //   cancelText: t('deleteConfirmDialog.cancelText')
      title: "Delete",
      text: "Type DELETE to confirm item delete",
      itemName: sensor.hwId,
      okText: "Delete",
      cancelText: "Cancel",
    });
    if (!userConfirmed) {
      return;
    }
    const body = {
      hwId: sensor.hwId,
      siteId: selectedSensorSite.customerId,
      edgeUnitId: selectedSensorSite.deviceId,
    };
    const response = await sensorManagement.delete(config.CONFIGURATION_URL, body);
    if (response.error) {
      console.error("Error deleting sensor:", response.error);
      return;
    }
    fetchSensorsForEdgeUnit();
  };

  if (!editing) {
    return (
      <>
        <DeleteConfirmationDialog />
        <Paper key={sensor.hwId} sx={{ px: 1, marginBottom: 1, maxWidth: 700 }} elevation={2}>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Typography sx={{ flex: 2, alignSelf: "center" }}>{sensor.hwId}</Typography>
            <Typography sx={{ flex: 2, alignSelf: "center" }}>{sensor.sensorName}</Typography>
            <Stack direction="row" gap={2} sx={{ flex: 1, justifyContent: "flex-end" }}>
              <IconButton
                aria-label="copy"
                onClick={() => {
                  copySensorToNewSensorCard(sensor);
                }}
              // color="info"
              >
                <ContentCopyIcon />
              </IconButton>
              <IconButton aria-label="edit" onClick={() => setEditing(!editing)}>
                <EditIcon />
              </IconButton>
              <IconButton aria-label="delete" color="error" onClick={deleteSensor}>
                <DeleteForeverIcon />
              </IconButton>
            </Stack>
          </Box>
        </Paper>
      </>
    );
  }

  return (
    <SensorCard
      sensor={sensor}
      selectedSensorSite={selectedSensorSite}
      editing={true}
      handleSetEditing={handleSetEditing}
      fetchSensorsForEdgeUnit={fetchSensorsForEdgeUnit}
    />
  );
};

export default SensorManagementListItem;
